import { observer } from "mobx-react-lite";
import { Button, Center } from "@chakra-ui/react";

import { langStore, translate, useSafeExecute, useSelecting } from "@noli/business";

import { Editor_Words } from "@/utils/lang/editor";

function DeletePanel() {
  const lang = langStore.tgt;
  const { type, nodes } = useSelecting("raw");

  if (type === "none") {
    return null;
  }

  function onDelete(): void {
    useSafeExecute("remove", null, true)(nodes.map((node) => node.alias));
  }

  return (
    <Center>
      <Button variant="outline" w="80%" mb="24px" onClick={onDelete}>
        {translate(Editor_Words["delete"], lang)}
      </Button>
    </Center>
  );
}

export default observer(DeletePanel);
